const COLORS = [
  'blue', 'teal', 'green', 'yellow',
  'red', 'pink', 'purple', 'orange',
  'cyan', 'lime', 'rose', 'fuchsia',
];

/**
 * タグ名から色を決定論的に導出する。
 * 同じタグ名は常に同じ色になる（DBへの保存不要）。
 */
export function tagColor(tag) {
  if (!tag) return null;
  let h = 0;
  for (let i = 0; i < tag.length; i++) {
    h = (h * 31 + tag.charCodeAt(i)) >>> 0;
  }
  return COLORS[h % COLORS.length];
}
